module.exports = __webpack_public_path__ + "img/shoushi03.3b019c79.png";